<template>
  <div>
    <Breadcrumb :key="$route.path" />
    <div class="container-fluid bgc-container">
      <div class="row successfull mt-2">
        <div class="col">
          <img
            src="@/assets/images/group-3-copy-3@3x.png"
            class="done-logo"
            alt="done"
          />
        </div>
      </div>
      <!-- Thank You -->
      <div class="row">
        <div class="col text-center">
          <p class="thank-you mt-3 mb-3">Endrosement Application Submitted</p>
          <p class="mt-4 mb-2">Application for Policy No
            <b><span class="policy-no">1234 3212 3411 2187</span></b
            >
          </p>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-12">
          <button
            id="issue_another_endorse"
            type="button"
            class="btn bgc-btn-primary float-right my-5"
            data-dismiss="modal"
          >
            Issue another Endorsement
          </button>
          <button id="trans_own_successpage" class="bgc-btn-secondary float-right mr-4 my-5 " type="button">Back</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/../../shared_component/Breadcrumb.vue";
import { reactive } from "@vue/composition-api";
export default {
  name: "transferOfOwnerSuccessPg",
  components: {
    Breadcrumb,
  },
   setup() {
    let state = reactive({});
    return {
      state
    };
  },
};
</script>

<style scoped>
.done-logo {
  margin-top: 24px;
  text-align: center;
}
.policy-no {
  font-weight: bold;
  color: #0070be;
}
.successfull {
  text-align: center;
}
.thank-you {
  font-size: 30px;
  color: #333333;
}
.btn:hover {
  color: #ffffff;
}
@media (max-width: 575px) {
  .thank-you {
    font-size: 24px;
  }
}
</style>
